import { defaultSoneiumProviderConfiguration } from '../default-constants';

export const KYO_FINANCE_CONTRACT_ADDRESS = '0x3c56C7C1Bfd9dbC14Ab04935f409d49D3b7A802E';

export const KYO_FINANCE_PROVIDER_CONFIGURATION = defaultSoneiumProviderConfiguration;
